import React, {useRef, useState} from 'react';
import {Box} from "@twilio-paste/core";
import styles from "../components/whatsapp/twilio-react/styles";
import App from "../components/whatsapp/twilio-react/components/App";
export const SussdWhatsAppContext = React.createContext({});
function SussdWhatsAppProvider({children}) {
    const [keyChange, setKeyChange] = useState(0);
    const [newMessages, setNewMessages] = useState(0);
    const doKeyChange = () => {
        setKeyChange((prev) => prev + 1);
    }
    const timer = useRef()
    const resetKey = () => {
        if (timer.current) {
            clearTimeout(timer.current);
        }
        timer.current = setTimeout(doKeyChange, 1000);
    };

    const Screen =  window.location.hostname === 'localhost' ? null : <WhatsAppScreen key={keyChange} setNewMessages={setNewMessages} resetKey={resetKey}/>;
    return (
        <SussdWhatsAppContext.Provider
        value={{Screen, unreadMessages:newMessages, resetKey}}>{children}</SussdWhatsAppContext.Provider>
    );
}
function WhatsAppScreen({setNewMessages, resetKey}) {
    console.log('key reset!@!!')

    return (
        <div style={{maxWidth: '100%'}}>

            <Box style={styles.app}>
                <App setNewMessages={setNewMessages} resetKey={resetKey}/>
            </Box>
        </div>


    )
}
export default SussdWhatsAppProvider;